import { render } from "./m-edit-zone.vue?vue&type=template&id=5ac770bd&scoped=true"
import script from "./m-edit-zone.vue?vue&type=script&lang=js"
export * from "./m-edit-zone.vue?vue&type=script&lang=js"

import "./m-edit-zone.vue?vue&type=style&index=0&id=5ac770bd&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac770bd"]])

export default __exports__